import { GetModelsByModelIdApiResponse } from "infra/api/generated/api";

import { Box, Center, Fade, Progress, Text, VStack } from "@chakra-ui/react";

export const ModelStatusSection = ({
  model,
}: {
  model: GetModelsByModelIdApiResponse["model"];
}) => {
  const statusRenderers = {
    failed: () => {
      return (
        <Fade in>
          <VStack>
            <Text pt={4} size="title.md">
              The model failed to train.
            </Text>
            <Text py={2} color="textSecondary" size="body.lg">
              Please head over to the model settings and initiate a new
              training.
            </Text>
          </VStack>
        </Fade>
      );
    },
    training: () => {
      const isTrainingQueued =
        model.trainingProgress?.stage !== "running-train";
      return (
        <Fade in>
          <VStack>
            <Text pt={6} size="title.md">
              {isTrainingQueued
                ? "Queued for training"
                : "Training in progress"}
            </Text>
            <Text pt={2} color="textSecondary" size="body.lg">
              You will receive an email notification once the model training is
              complete.
            </Text>
            <Box pt={6} pb={2}>
              <Progress
                w={"350px"}
                h={1.5}
                isIndeterminate={isTrainingQueued}
                rounded="base"
                size="xs"
                value={
                  isTrainingQueued
                    ? undefined
                    : (model.trainingProgress?.progress ?? 0) * 100
                }
              />
            </Box>
          </VStack>
        </Fade>
      );
    },
    default: () => (
      <Fade in>
        <Text size="title.md">Status: {model.status}</Text>
      </Fade>
    ),
  };

  const renderStatusCard =
    statusRenderers[model.status as keyof typeof statusRenderers];

  return (
    <>
      {renderStatusCard && (
        <Center mb={4} p={3} bg="gray.900" rounded="xl">
          {renderStatusCard()}
        </Center>
      )}
    </>
  );
};
